import axios from 'axios'
import { apiURL, appVersion, platformWeb, commonHeadersWeb, getCountryCode } from './index'
import { v4 as uuidv4 } from 'uuid'
import { APP_CONSTANTS } from 'src/consumer/constants'
import logo from 'src/assets/logo_brand.png'
import { toast } from 'react-toastify'
// Stripe is loaded dynamically only when needed to avoid blocking initial page load
// import { loadStripe } from '@stripe/stripe-js'
import { getRazorpayLanguageCode } from '../components/EventBooking/BookingHelperFunctions'
import { ensureRazorpayLoaded } from 'src/utils/loadRazorpay'

export const createOrder = async (plan, method, gateway) => {
  const languageCode = sessionStorage.getItem('languageCode')
  const token = localStorage.getItem('token')
  const clientTransactionId = uuidv4()

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/${gateway}/one-time-purchase/payload?pkgId=&paywall=upgrade&paymentMethod=${method}&planId=${plan}&clientTransactionId=${clientTransactionId}&languageCode=${languageCode}&appVersion=${appVersion}&platform=${platformWeb}&cancelUrl=${encodeURIComponent(
        window.location.href,
      )}&successUrl=${encodeURIComponent(window.location.href)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
    return error
  }
}

export const displayRazorpay = async (
  orderResponse,
  successMessage,
  afterSuccessFunction = () => {
    window.location.reload()
  },
) => {
  try {
    await ensureRazorpayLoaded()
  } catch (error) {
    console.error('[Razorpay] Failed to load checkout.js', error)
    toast.error('Payment gateway failed to load. Please refresh the page and try again.')
    return
  }

  const key = orderResponse?.razorpayClientId
  const amount = orderResponse?.amount || 29900
  const currency = orderResponse?.currency || 'INR'
  const name = 'AUMHUM'
  const description = orderResponse?.description
  const order_id = orderResponse?.orderId
  const userName = orderResponse?.userName
  const userEmail = orderResponse?.userEmail
  const userMobile = orderResponse?.userMobile

  var options = {
    key: key, // Enter the Key ID generated from the Dashboard
    amount: amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    currency: currency,
    name: name, //your business name
    description: description,
    image: APP_CONSTANTS.APP_LOGO_LINK,
    order_id: order_id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
    handler: function (response) {
      successMessage && alert(successMessage)
      afterSuccessFunction()
      // window.location.reload()
    },
    prefill: {
      name: userName, //your customer's name
      email: userEmail,
      contact: userMobile,
    },
    config: {
      display: {
        blocks: {
          banks: {
            name: 'Preferred Method',
            instruments: [
              {
                method: 'upi',
              },
            ],
          },
        },
        hide: [
          {
            method: 'paylater',
          },
        ],
        sequence: ['block.banks'],
        preferences: {
          show_default_blocks: true,
        },
        language: getRazorpayLanguageCode(),
      },
    },
    notes: {
      address: 'Bangalore',
    },
    theme: {
      color: '#7154b0',
    },
  }

  var rzp1 = new window.Razorpay(options)
  rzp1.on('payment.failed', function (response) {
    console.log(response.error.description)
    console.log(response.error.code)
    console.log(response.error.source)
    console.log(response.error.step)
    console.log(response.error.reason)
    console.log(response.error.metadata.order_id)
    console.log(response.error.metadata.payment_id)
  })
  rzp1.open()
}

export const makePayment = async (
  planId,
  paymentMethod,
  gateway,
  successMessage,
  closeWall,
  afterSuccessFunction,
  loadingSetter,
) => {
  loadingSetter(gateway)
  const response = await createOrder(planId, paymentMethod, gateway)
  loadingSetter(null)
  if (response?.status === 200) {
    let orderResponse = response?.data
    if (gateway === 'razorpay') {
      closeWall && closeWall()
      displayRazorpay(orderResponse, successMessage, afterSuccessFunction)
    } else if (gateway === 'stripe') {
      try {
        // Dynamically import Stripe only when needed to avoid blocking initial page load
        const { loadStripe } = await import('@stripe/stripe-js')
        const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)
        const stripe = await stripePromise

        const { sessionId } = response?.data
        const { error } = await stripe.redirectToCheckout({
          sessionId: sessionId,
        })

        if (error) {
          console.error('Error redirecting to Stripe Checkout:', error)
          toast.error('Error redirecting to Stripe Checkout')
        }
      } catch (error) {
        console.error('Error loading Stripe:', error)
        toast.error('Error loading Stripe')
      }
    }
  } else {
    toast.error('Error, please try again')
  }
}
